import React from 'react';
import { Box, Container, Typography, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';

const FAQs = () => {
    const faqs = [
        {
            question: 'What is 10D Stores?',
            answer: '10D Stores is a hyperlocal commerce platform that connects customers with local businesses, offering exclusive deals, seamless shopping experiences, and digital convenience.'
        },
        {
            question: 'How do I register as a business?',
            answer: 'You can register your business by clicking on the "Partner with 10D" link in the footer or visiting the Business page. Fill out the form, and our team will get in touch with you.'
        },
        {
            question: 'Is there a membership fee for customers?',
            answer: 'Basic membership is free for all customers. We also offer premium subscription plans that unlock additional benefits and higher discounts.'
        },
        {
            question: 'How do I return an item?',
            answer: 'Returns are handled directly by the respective store partners according to their return policies. You can initiate a return request through your order history in the app.'
        },
        {
            question: 'Is my payment information secure?',
            answer: 'Yes, we use industry-standard encryption and secure payment gateways to ensure your financial information is always protected.'
        },
        {
            question: 'Can I change my delivery address after placing an order?',
            answer: 'You can change your delivery address if the order has not yet been dispatched. Please contact customer support or the store directly for assistance.'
        }
    ];

    return (
        <Box sx={{ minHeight: '100vh', backgroundColor: '#f8fafc', py: 10 }}>
            <Container maxWidth="md">
                <Typography variant="h3" component="h1" sx={{ fontWeight: 800, mb: 2, textAlign: 'center' }}>
                    Frequently Asked Questions
                </Typography>
                <Typography variant="h6" color="text.secondary" sx={{ mb: 8, textAlign: 'center' }}>
                    Find answers to common questions about 10D Stores.
                </Typography>

                <Box>
                    {faqs.map((faq, index) => (
                        <Accordion key={index} sx={{ mb: 2, borderRadius: 2, boxShadow: '0 2px 10px rgba(0,0,0,0.05)', '&:before': { display: 'none' } }}>
                            <AccordionSummary expandIcon={<ExpandMore />}>
                                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                                    {faq.question}
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography variant="body1" color="text.secondary">
                                    {faq.answer}
                                </Typography>
                            </AccordionDetails>
                        </Accordion>
                    ))}
                </Box>
            </Container>
        </Box>
    );
};

export default FAQs;
